import { atom } from 'jotai';
import type { Message, WsChatSidebarConfig } from 'pages/ws/components/chatSidebar/WsChatSidebar';

/**
 * チャットサイドバー状態管理
 */
export type ChatStateType = {
  open: boolean;
  messages: Message[];
  config: WsChatSidebarConfig | null;
  setMessage: ((message: string, autoSend?: boolean) => Promise<void>) | null;
};

export const ChatState = atom<ChatStateType>({
  open: false,
  messages: [],
  config: null,
  setMessage: null,
});
